(function() {
    'use strict';

    angular
        .module('app')
        .controller('phoneNumberModalController', phoneNumberModalController);

    function phoneNumberModalController($uibModalInstance, loginService, $rootScope, $uibModalStack) {
        var vm = this;
        vm.cancel = cancel;
        vm.sendVerifyCodeFromPhone = sendVerifyCodeFromPhone;
        vm.checkVerify = checkVerify;
        vm.isSended = false;

        init();

        function init() {
            loginService.getSsoInfo().then(function(data) {
                vm.form1 = {
                    userAccount: data.data.userAccount,
                    tel: data.data.tel
                };
            });
        }

        function cancel() {
            $uibModalInstance.dismiss('cancel');
        }

        function sendVerifyCodeFromPhone() {
            loginService.sendVerifyCodeFromPhone(vm.form1.userAccount).then(() => {
                toastr.success($rootScope.translate.commonAlreadySendSMS);
            });
            vm.isSended=true;
        }

        function checkVerify() {
            var param = {
                verifyCode: vm.form1.validCode,
                userAccount: vm.form1.userAccount,
                PhoneNumber: vm.form1.tel
            };
            loginService.verifyCodeCheckFromPhone(param).then(function(data) {
                if (data) {
                    toastr.success($rootScope.translate.alreadyVerifyPhoneNumber);
                    $uibModalStack.dismissAll();
                }
            });
        }
    }
})();
